import Vue from "vue";
import Router from "vue-router";

import en from "../../lang/en/messages";
import ch from "../../lang/ch/messages";

Vue.use(Router);

// console.log("server testing hbjhb");
// console.log("router inside portal type", process.env);
var val = localStorage.getItem("locale");
var messages;
if (val == "ch") messages = ch;
else messages = en;
var router;
// This route is for Organization
if (process.env.PORTAL_TYPE == "ORGANIZATION") {
    router = new Router({
        mode: "history",
        routes: [{
                path: "",
                redirect: "login"
            },
            {
                path: "/login",
                name: "Login",
                component: () =>
                    import ("@/views/login/login")
            },
            {
                path: "/forget-password",
                name: "Forgetpassword",
                component: () =>
                    import ("@/views/login/forgetPassword")
            },
            {
                path: "/verification",
                name: "mfaVerification",
                component: () =>
                    import ("@/views/login/mfaVerification.vue")
            },
            {
                path: "/reset-password/:token",
                name: "ResetPassword",
                component: () =>
                    import ("@/views/login/resetPassword")
            },
            {
                path: "/complete-activation/:token",
                name: "CompleteActivation",
                component: () =>
                    import ("@/views/login/accountActivation")
            },
            {
                path: "/",
                component: () =>
                    import ("@/views/main"),
                meta: {
                    requiresAuth: true
                },
                children: [{
                        path: "/profile",
                        name: "Profile",
                        component: () =>
                            import ("@/views/Profile/profile"),
                        meta: {
                            title: messages.profile,
                            breadcrumb: [
                                { name: messages.profile },
                                { name: messages.profile }
                            ]
                        }
                    },

                    {
                        path: "/change-password",
                        name: "ChangePassword",
                        component: () =>
                            import ("@/views/Profile/changePassword"),
                        meta: {
                            title: messages.change_password,
                            breadcrumb: [
                                { name: messages.change_password },
                                { name: messages.change_password }
                            ]
                        }
                    },
                    {
                        path: "/information",
                        name: "/My Information",
                        component: () =>
                            import ("@/views/Organization/MyInformation/my-information")
                            // meta: {
                            //   title: messages.My_Contracts,
                            //   breadcrumb: [
                            //     { name: messages.My_Contracts },
                            //     { name: messages.My_Contracts }
                            //   ]
                            // }
                    },
                    {
                        path: "/add-my-bank",
                        name: "/Add Bank",
                        component: () =>
                            import ("@/views/Organization/MyInformation/setBankingInfo")
                            // meta: {
                            //   title: messages.My_Contracts,
                            //   breadcrumb: [
                            //     { name: messages.My_Contracts },
                            //     { name: messages.My_Contracts }
                            //   ]
                            // }
                    },
                    {
                        path: "/edit-my-bank/:id",
                        name: "/Edit Bank",
                        component: () =>
                            import ("@/views/Organization/MyInformation/setBankingInfo")
                            // meta: {
                            //   title: messages.My_Contracts,
                            //   breadcrumb: [
                            //     { name: messages.My_Contracts },
                            //     { name: messages.My_Contracts }
                            //   ]
                            // }
                    },
                    {
                        path: "/contracts",
                        name: "contracts",
                        component: () =>
                            import ("@/views/Organization/ManageContract/contract"),
                        meta: {
                            title: messages.manage_contract,
                            breadcrumb: [
                                { name: messages.manage_contract },
                                { name: messages.manage_contract }
                            ]
                        }
                    },
                    {
                      path: "/welcome-Page",
                      name: "WelcomePage",
                      component: () =>import ("@/views/Organization/DashBoard/welcome"),
                  },

                    {
                        path: "/add-contract",
                        name: "addContract",
                        component: () =>
                            import ("@/views/Organization/ManageContract/addContract")
                    },
                    {
                        path: "/edit-contract/:uuid",
                        name: "EditContract",
                        component: () =>
                            import ("@/views/Organization/ManageContract/EditContract")
                    },

                    {
                        path: "/users",
                        name: "Users",
                        component: () =>
                            import ("@/views/Organization/ManageUser/users"),
                        meta: {
                            title: messages.my_user,
                            breadcrumb: [
                                { name: messages.my_user },
                                { name: messages.my_user }
                            ]
                        }
                    },

                    {
                        path: "/add-user",
                        name: "Addusers",
                        component: () =>
                            import ("@/views/Organization/ManageUser/addUser")
                    },
                    {
                        path: "/edit-user/:id",
                        name: "EditUser",
                        component: () =>
                            import ("@/views/Organization/ManageUser/addUser")
                    },
                    {
                        path: "/view-user/:id",
                        name: "Edit-Users",
                        component: () =>
                            import ("@/views/Organization/ManageUser/viewUser")
                    },
                    {
                        path: "/doc-types",
                        name: "ManageDoc",
                        component: () =>
                            import ("@/views/Organization/ManageDocType/docType"),
                        meta: {
                            title: messages.manage_doc_type,
                            breadcrumb: [
                                { name: messages.manage_doc_type },
                                { name: messages.manage_doc_type }
                            ]
                        }
                    },
                    {
                        path: "/add-doc-type",
                        name: "AddDocType",
                        component: () =>
                            import ("@/views/Organization/ManageDocType/addEditDocType")
                    },
                    {
                        path: "/edit-doc-type/:id",
                        name: "EditDocType",
                        component: () =>
                            import ("@/views/Organization/ManageDocType/addEditDocType")
                    },
                    {
                        path: "/master-onboarding",
                        name: "ManageMasterOnboarding",
                        component: () =>
                            import ("@/views/Organization/ManageMasterOnboarding/list"),
                        meta: {
                            title: messages.master_onboarding,
                            breadcrumb: [
                                { name: messages.master_onboarding },
                                { name: messages.master_onboarding }
                            ]
                        }
                    },
                    {
                        path: "/master-onboarding/:id",
                        name: "ManageMasterOnboardingList",
                        component: () =>
                            import ("@/views/Organization/ManageMasterOnboarding/docType"),
                    },
                    {
                        path: "/add-master-question/:master_id",
                        name: "AddMasterQuestion",
                        component: () =>
                            import ("@/views/Organization/ManageMasterOnboarding/addEditDocType")
                    },
                    {
                        path: "/edit-master-question/:id/master/:master_id",
                        name: "EditMasterQuestion",
                        component: () =>
                            import ("@/views/Organization/ManageMasterOnboarding/addEditDocType")
                    },
                    {
                        path: "/onboarding-check",
                        name: "ManageOnboardingCheck",
                        component: () =>
                            import ("@/views/Organization/ManageOnboarding/onboarding"),
                        meta: {
                            title: messages.manage_onboarding_check,
                            breadcrumb: [
                                { name: messages.manage_onboarding_check },
                                { name: messages.manage_onboarding_check }
                            ]
                        }
                    },
                    {
                        path: "/edit-onboarding-check/:id",
                        name: "EditOnBoarding",
                        component: () =>
                            import ("@/views/Organization/ManageOnboarding/editOnboarding")
                    },
                    {
                        path: "/my-tasks",
                        name: "MyTaskList",
                        component: () =>
                            import ("@/views/Organization/Tasks/myTaskList"),
                        meta: {
                            title: messages.my_task_list,
                            breadcrumb: [
                                { name: messages.my_task_list },
                                { name: messages.my_task_list }
                            ]
                        }
                    },
                    {
                        path: "/assigned-tasks",
                        name: "AssignedTaskList",
                        component: () =>
                            import ("@/views/Organization/Tasks/assignedTask"),
                        meta: {
                            title: messages.assigned_task_list,
                            breadcrumb: [
                                { name: messages.assigned_task_list },
                                { name: messages.assigned_task_list }
                            ]
                        }
                    },
                    {
                        path: "/agency-clients",
                        name: "ManageAgencies",
                        component: () =>
                            import ("@/views/Organization/ManageAgencies/agency"),
                        meta: {
                            title: messages.manage_agencies,
                            breadcrumb: [
                                { name: messages.manage_agencies },
                                { name: messages.manage_agencies }
                            ]
                        }
                    },
                    {
                        path: "/add-agencies",
                        name: "AddManageAgencies",
                        component: () =>
                            import ("@/views/Organization/ManageAgencies/addAgencies")
                    },
                    {
                        path: "/invoice-list",
                        name: "ManageInvoiceAgencies",
                        component: () =>
                            import ("@/views/Organization/MonthlyInvoices/invoiceView")
                    },
                    {
                        path: "/edit-agencies/:uuid",
                        name: "EditManageAgencies",
                        component: () =>
                            import ("@/views/Organization/ManageAgencies/editAgencies")
                    },
                    {
                        path: "/contractors",
                        name: "contractors",
                        component: () =>
                            import ("@/views/Organization/ManageContractor/contractor"),
                        meta: {
                            title: messages.manage_contractors,
                            breadcrumb: [
                                { name: messages.manage_contractors },
                                { name: messages.manage_contractors }
                            ]
                        }
                    },
                    {
                        path: "/add-contractor",
                        name: "AddContractorCompanies",
                        component: () =>
                            import ("@/views/Organization/ManageContractor/addContractor")
                    },
                    {
                        path: "/edit-contractor/:id",
                        name: "EditContractorCompanies",
                        component: () =>
                            import ("@/views/Organization/ManageContractor/EditContractors")
                    },
                    {
                        path: "/view-contractor/:id",
                        name: "ViewContractorCompanies",
                        component: () =>
                            import ("@/views/Organization/ManageContractor/ViewContractors")
                    },
                    {
                        path: "/add-banking-info/:id/:type",
                        name: "addEditBankinginfo",
                        component: () =>
                            import (
                                "@/views/Organization/commonBankingForm/addEditBankingInfo"
                            ),
                        meta: {
                            title: messages.banking_info,
                            breadcrumb: [
                                { name: messages.edit_contractor_companies },
                                { name: messages.edit_contractor_companies }
                            ]
                        }
                    },
                    {
                        path: "/edit-banking-info/:id/:bank_id/:type",
                        name: "addEditBankinginfo",
                        component: () =>
                            import (
                                "@/views/Organization/commonBankingForm/addEditBankingInfo"
                            ),
                        meta: {
                            title: messages.banking_info,
                            breadcrumb: [
                                { name: messages.edit_contractor_companies },
                                { name: messages.edit_contractor_companies }
                            ]
                        }
                    },

                    {
                        path: "/leads",
                        name: "LeadsAndDeals",
                        component: () =>
                            import ("@/views/Organization/ManageLeads/leads"),
                        meta: {
                            title: messages.manage_leads,
                            breadcrumb: [
                                { name: messages.manage_leads },
                                { name: messages.manage_leads }
                            ]
                        }
                    },
                    {
                        path: "/invoices",
                        name: "InvoicesList",
                        component: () =>
                            import ("@/views/Organization/MonthlyInvoices/invoices"),
                        // meta: {
                        //     title: messages.monthly_invoice,
                        //     breadcrumb: [
                        //         { name: messages.monthly_invoice },
                        //         { name: messages.monthly_invoice }
                        //     ]
                        // }
                    },
                    {
                        path: "/payroll-invoices",
                        name: "PayrollInvoices",
                        component: () =>
                            import ("@/views/Organization/ManagePayrollInvoice/invoices"),
                        // meta: {
                        //     title: messages.payroll_invoice,
                        //     breadcrumb: [
                        //         { name: messages.payroll_invoice },
                        //         { name: messages.payroll_invoice }
                        //     ]
                        // }
                    },
                    {
                        path: "/contractor-invoices",
                        name: "ContractorInvoices",
                        component: () =>
                            import ("@/views/Organization/ManageContractorInvoice/invoices"),
                        // meta: {
                        //     title: messages.contractor_invoice,
                        //     breadcrumb: [
                        //         { name: messages.contractor_invoice },
                        //         { name: messages.contractor_invoice }
                        //     ]
                        // }
                    },
                    {
                        path: "/payroll-partners",
                        name: "PayrollPartner",
                        component: () =>
                            import ("@/views/Organization/PayrollPartner/payrollPartner"),
                        meta: {
                            title: messages.payroll_partner,
                            breadcrumb: [
                                { name: messages.payroll_partner },
                                { name: messages.payroll_partner }
                            ]
                        }
                    },
                    {
                        path: "/add-payroll-partner",
                        name: "AddPayrollPartner",
                        component: () =>
                            import ("@/views/Organization/PayrollPartner/addPayrollPartner")
                            // meta: {
                            //   title: messages.add_payroll_partner,
                            //   breadcrumb: [
                            //     { name: messages.add_payroll_partner },
                            //     { name: messages.add_payroll_partner }
                            //   ]
                            // }
                    },
                    {
                        path: "/edit-payroll-partner/:id",
                        name: "AddPayrollPartner",
                        component: () =>
                            import ("@/views/Organization/PayrollPartner/EditPayrollPartner")
                            // meta: {
                            //   title: messages.edit_payroll_partner,
                            //   breadcrumb: [
                            //     { name: messages.edit_payroll_partner },
                            //     { name: messages.edit_payroll_partner }
                            //   ]
                            // }
                    },
                    {
                        path: "/payslips",
                        name: "Payslips",
                        component: () =>
                            import ("@/views/Organization/ManagePayslips/payslip"),
                        meta: {
                            title: messages.manage_payslip,
                            breadcrumb: [
                                { name: messages.manage_payslip },
                                { name: messages.manage_payslip }
                            ]
                        }
                    },
                    {
                        path: "/roles",
                        name: "Role",
                        component: () =>
                            import ("@/views/Organization/ManageSettings/ManageRole/role")
                            // meta: {
                            //   title: messages.manage_role,
                            //   breadcrumb: [
                            //     { name: messages.manage_role },
                            //     { name: messages.manage_role }
                            //   ]
                            // }
                    },
                    {
                        path: "/add-role",
                        name: "Add-role",
                        component: () =>
                            import (
                                "@/views/Organization/ManageSettings/ManageRole/addEditRole"
                            )
                    },
                    {
                        path: "/edit-role/:id",
                        name: "Edit-role",
                        component: () =>
                            import (
                                "@/views/Organization/ManageSettings/ManageRole/addEditRole"
                            )
                    },

                    {
                        path: "/organization",
                        name: "Organization",
                        component: () =>
                            import (
                                "@/views/Organization/ManageSettings/ManageOrganization/organization"
                            ),
                        meta: {
                            title: messages.manage_organization,
                            breadcrumb: [
                                { name: messages.manage_organization },
                                { name: messages.manage_organization }
                            ]
                        }
                    },
                    {
                        path: "/add-organization",
                        name: "AddOrganization",
                        component: () =>
                            import (
                                "@/views/Organization/ManageSettings/ManageOrganization/addOrg"
                            ),
                        meta: {
                            title: messages.add_organization,
                            breadcrumb: [
                                { name: messages.add_organization },
                                { name: messages.add_organization }
                            ]
                        }
                    },
                    {
                        path: "/countries",
                        name: "Coutries",
                        component: () =>
                            import (
                                "@/views/Organization/ManageSettings/ManageCountry/countryList"
                            ),
                        meta: {
                            title: messages.manage_countries,
                            breadcrumb: [
                                { name: messages.manage_countries },
                                { name: messages.manage_countries }
                            ]
                        }
                    },
                    {
                        path: "/edit-organization/:id",
                        name: "EditOrganization",
                        component: () =>
                            import (
                                "@/views/Organization/ManageSettings/ManageOrganization/editOrganization"
                            ),
                        meta: {
                            title: messages.edit_organization,
                            breadcrumb: [
                                { name: messages.edit_organization },
                                { name: messages.edit_organization }
                            ]
                        }
                    },
                    {
                        path: "/reports",
                        name: "Report",
                        component: () =>
                            import ("@/views/Organization/Reports/report"),
                        meta: {
                            title: messages.manage_reports,
                            breadcrumb: [
                                { name: messages.manage_reports },
                                { name: messages.manage_reports }
                            ]
                        }
                    },

                    {
                        path: "/agency-list",
                        name: "ManageAgency",
                        component: () =>
                            import ("@/views/Organization/ManageAgencies/agency"),
                        meta: {
                            title: messages.manage_agency,
                            breadcrumb: [
                                { name: messages.manage_agency },
                                { name: messages.manage_agency }
                            ]
                        }
                    }
                ]
            }
        ]
    });
}

// This route is for Agency
if (process.env.PORTAL_TYPE == "AGENCY") {
    router = new Router({
        mode: "history",
        routes: [{
                path: "",
                redirect: "login"
            },
            {
                path: "/login",
                name: "Login",
                component: () =>
                    import ("@/views/login/login")
            },
            {
                path: "/forget-password",
                name: "Forgetpassword",
                component: () =>
                    import ("@/views/login/forgetPassword")
            },
            {
              path: "/verification",
              name: "mfaVerification",
              component: () =>
                  import ("@/views/login/mfaVerification.vue")
          },
            {
                path: "/reset-password/:token",
                name: "ResetPassword",
                component: () =>
                    import ("@/views/login/resetPassword")
            },
            {
                path: "/complete-activation/:token",
                name: "CompleteActivation",
                component: () =>
                    import ("@/views/login/accountActivation")
            },
            {
                path: "/",
                component: () =>
                    import ("@/views/main"),
                meta: {
                    requiresAuth: true
                },
                children: [
                    {
                        path: "/profile",
                        name: "Profile",
                        component: () =>
                            import ("@/views/Profile/profile"),
                        meta: {
                            title: messages.profile,
                            breadcrumb: [
                                { name: messages.profile },
                                { name: messages.profile }
                            ]
                        }
                    },


                    {
                        path: "/change-password",
                        name: "ChangePassword",
                        component: () =>
                            import ("@/views/Profile/changePassword"),
                        meta: {
                            title: messages.change_password,
                            breadcrumb: [
                                { name: messages.change_password },
                                { name: messages.change_password }
                            ]
                        }
                    },
                    {
                        path: "/welcome-Page",
                        name: "WelcomePage",
                        component: () =>import ("@/views/Agency/DashBoard/welcome"),
                    },
                    {
                        path: "/information",
                        name: "Information",
                        component: () =>
                            import ("@/views/Agency/MyInformation/information"),
                        meta: {
                            title: messages.manage_information,
                            breadcrumb: [
                                { name: messages.manage_information },
                                { name: messages.manage_information }
                            ]
                        }
                    },
                    {
                        path: "/my-contracts",
                        name: "My Contarct",
                        component: () =>
                            import ("@/views/Agency/ManageContract/contract"),
                        meta: {
                            title: messages.my_contract,
                            breadcrumb: [
                                { name: messages.my_contract },
                                { name: messages.my_contract }
                            ]
                        }
                    },
                    {
                        path: "/edit-contract/:id/:view",
                        name: "Edit Contract",
                        component: () =>
                            import ("@/views/Agency/ManageContract/editContract")
                            // meta: {
                            //   title: messages.my_contract,
                            //   breadcrumb: [
                            //     { name: messages.my_contract },
                            //     { name: messages.my_contract }
                            //   ]
                            // }
                    },
                    {
                        path: "/invoices",
                        name: "Manage Invoices",
                        component: () =>
                            import ("@/views/Agency/MonthlyInvoices/invoices"),
                        // meta: {
                        //     title: messages.monthly_invoice,
                        //     breadcrumb: [
                        //         { name: messages.monthly_invoice },
                        //         { name: messages.monthly_invoice }
                        //     ]
                        // }
                    },
                    // {
                    //     path: "/invoices",
                    //     name: "Manage Invoices",
                    //     component: () =>
                    //         import ("@/views/Agency/MonthlyInvoices/invoices"),
                    //     meta: {
                    //         title: messages.monthly_invoice,
                    //         breadcrumb: [
                    //             { name: messages.monthly_invoice },
                    //             { name: messages.monthly_invoice }
                    //         ]
                    //     }
                    // },

                    {
                        path: "/users",
                        name: "Users",
                        component: () =>
                            import ("@/views/Agency/ManageUser/Users"),
                        meta: {
                            title: messages.manage_users,
                            breadcrumb: [
                                { name: messages.manage_users },
                                { name: messages.manage_users }
                            ]
                        }
                    },
                    {
                        path: "/add-agency-user",
                        name: "Add-Users",
                        component: () =>
                            import ("@/views/Agency/ManageUser/adduser")
                            // meta: {
                            //   title: messages.add_users,
                            //   breadcrumb: [
                            //     { name: messages.add_users },
                            //     { name: messages.add_users }
                            //   ]
                            // }
                    },
                    {
                        path: "/edit-agency-user/:id",
                        name: "Edit-Users",
                        component: () =>
                            import ("@/views/Agency/ManageUser/adduser")
                            // meta: {
                            //   title: messages.add_users,
                            //   breadcrumb: [
                            //     { name: messages.add_users },
                            //     { name: messages.add_users }
                            //   ]
                            // }
                    },
                    {
                        path: "/view-user/:id",
                        name: "Edit-Users",
                        component: () =>
                            import ("@/views/Agency/ManageUser/viewUser")
                            // meta: {
                            //   title: messages.add_users,
                            //   breadcrumb: [
                            //     { name: messages.add_users },
                            //     { name: messages.add_users }
                            //   ]
                            // }
                    },
                    {
                        path: "/roles",
                        name: "Roles",
                        component: () =>
                            import ("@/views/Agency/ManageSettings/ManageRole/role"),
                        meta: {
                            title: messages.manage_users,
                            breadcrumb: [
                                { name: messages.manage_users },
                                { name: messages.manage_users }
                            ]
                        }
                    },
                    {
                        path: "/add-role",
                        name: "Add Roles",
                        component: () =>
                            import ("@/views/Agency/ManageSettings/ManageRole/addEditRole")
                            // meta: {
                            //   title: messages.add_roles,
                            //   breadcrumb: [
                            //     { name: messages.add_roles },
                            //     { name: messages.add_roles }
                            //   ]
                            // }
                    },
                    {
                        path: "/edit-role/:id",
                        name: "Edit Roles",
                        component: () =>
                            import ("@/views/Agency/ManageSettings/ManageRole/addEditRole")
                            // meta: {
                            //   title: messages.edit_roles,
                            //   breadcrumb: [
                            //     { name: messages.edit_roles },
                            //     { name: messages.edit_roles }
                            //   ]
                            // }
                    },
                    {
                        path: "/activity-logs",
                        name: "Activity Logs",
                        component: () =>
                            import ("@/views/Agency/ActivityLog/activity-logs"),
                        meta: {
                            title: messages.activity_log,
                            breadcrumb: [
                                { name: messages.activity_log },
                                { name: messages.activity_log }
                            ]
                        }
                    }
                ]
            }
        ]
    });
}

// This route is for Contractor

if (process.env.PORTAL_TYPE == "CONTRACTOR") {
    router = new Router({
        mode: "history",
        routes: [{
                path: "",
                redirect: "login"
            },
            {
                path: "/login",
                name: "Login",
                component: () =>
                    import ("@/views/login/login")
            },
            {
                path: "/forget-password",
                name: "Forgetpassword",
                component: () =>
                    import ("@/views/login/forgetPassword")
            },
            {
              path: "/verification",
              name: "mfaVerification",
              component: () =>
                  import ("@/views/login/mfaVerification.vue")
          },
            {
                path: "/reset-password/:token",
                name: "ResetPassword",
                component: () =>
                    import ("@/views/login/resetPassword")
            },
            {
                path: "/complete-activation/:token",
                name: "CompleteActivation",
                component: () =>
                    import ("@/views/login/accountActivation")
            },
            {
                path: "/",
                component: () =>
                    import ("@/views/main"),
                meta: {
                    requiresAuth: true
                },
                children: [{
                        path: "/profile",
                        name: "Profile",
                        component: () =>
                            import ("@/views/Profile/profile"),
                        meta: {
                            title: messages.profile,
                            breadcrumb: [
                                { name: messages.profile },
                                { name: messages.profile }
                            ]
                        }
                    },

                    {
                        path: "/change-password",
                        name: "ChangePassword",
                        component: () =>
                            import ("@/views/Profile/changePassword"),
                        meta: {
                            title: messages.change_password,
                            breadcrumb: [
                                { name: messages.change_password },
                                { name: messages.change_password }
                            ]
                        }
                    },
                    {
                        path: "/information",
                        name: "Information",
                        component: () =>
                            import ("@/views/Contractor/MyInformation/information")
                            // meta: {
                            //   title: messages.manage_information,
                            //   breadcrumb: [
                            //     { name: messages.manage_information },
                            //     { name: messages.manage_information }
                            //   ]
                            // }
                    },
                    {
                        path: "/onboarding-check",
                        name: "ManageOnboardingCheck",
                        component: () =>
                            import ("@/views/Contractor/ManageOnboarding/onboarding"),
                        meta: {
                            title: messages.manage_onboarding_check,
                            breadcrumb: [
                                { name: messages.manage_onboarding_check },
                                { name: messages.manage_onboarding_check }
                            ]
                        }
                    },
                    {
                        path: "/edit-onboarding-check/:id",
                        name: "EditOnBoarding",
                        component: () =>
                            import ("@/views/Contractor/ManageOnboarding/editOnboarding")
                    },
                    {
                        path: "/add-bank-info",
                        name: "Add Banking Info",
                        component: () =>
                            import ("@/views/Contractor/MyInformation/addEditBankinginfo")
                            // meta: {
                            //   title: messages.manage_information,
                            //   breadcrumb: [
                            //     { name: messages.manage_information },
                            //     { name: messages.manage_information }
                            //   ]
                            // }
                    },
                    {
                        path: "/edit-bank-info/:bank_id",
                        name: "Edit Banking Info",
                        component: () =>
                            import ("@/views/Contractor/MyInformation/addEditBankinginfo")
                            // meta: {
                            //   title: messages.manage_information,
                            //   breadcrumb: [
                            //     { name: messages.manage_information },
                            //     { name: messages.manage_information }
                            //   ]
                            // }
                    },
                    {
                        path: "/contracts",
                        name: "My Contarct",
                        component: () =>
                            import ("@/views/Contractor/ManageContract/contract"),
                        meta: {
                            title: messages.my_contract,
                            breadcrumb: [
                                { name: messages.my_contract },
                                { name: messages.my_contract }
                            ]
                        }
                    },
                    {
                        path: "/welcome-Page",
                        name: "WelcomePage",
                        component: () =>import ("@/views/Contractor/DashBoard/welcome"),
                    },
                    {
                        path: "/edit-contract/:id/:view",
                        name: "Edit Contract",
                        component: () =>
                            import ("@/views/Contractor/ManageContract/editContract")
                            // meta: {
                            //   title: messages.my_contract,
                            //   breadcrumb: [
                            //     { name: messages.my_contract },
                            //     { name: messages.my_contract }
                            //   ]
                            // }
                    },
                    {
                        path: "/my-remits",
                        name: "My Remits",
                        component: () =>
                            import ("@/views/Contractor/MyRemits/my-remits"),
                        meta: {
                            title: messages.my_remits,
                            breadcrumb: [
                                { name: messages.my_remits },
                                { name: messages.my_remits }
                            ]
                        }
                    },
                    {
                        path: "/payslips",
                        name: "My Payslip",
                        component: () =>
                            import ("@/views/Contractor/MyPlayslip/payslips"),
                        meta: {
                            title: messages.my_payslips,
                            breadcrumb: [
                                { name: messages.my_payslips },
                                { name: messages.my_payslips }
                            ]
                        }
                    },
                    {
                        path: "/activity-logs",
                        name: "Activity Log",
                        component: () =>
                            import ("@/views/Contractor/ActivityLog/activity-logs"),
                        meta: {
                            title: messages.my_Activity_Log,
                            breadcrumb: [
                                { name: messages.my_Activity_Log },
                                { name: messages.my_Activity_Log }
                            ]
                        }
                    },
                    {
                        path: "/refer-friend",
                        name: "Refer Friend",
                        component: () =>
                            import ("@/views/Contractor/ReferFriend/refer-friend"),
                        meta: {
                            title: messages.ReferFriend,
                            breadcrumb: [
                                { name: messages.ReferFriend },
                                { name: messages.ReferFriend }
                            ]
                        }
                    },
                    {
                        path: "/add-friend",
                        name: "Add Friend",
                        component: () =>
                            import ("@/views/Contractor/ReferFriend/addEditFriend")
                            // meta: {
                            //   title: messages.ReferFriend,
                            //   breadcrumb: [
                            //     { name: messages.ReferFriend },
                            //     { name: messages.ReferFriend }
                            //   ]
                            // }
                    },
                    {
                        path: "/view-friend/:id",
                        name: "Edit Friend",
                        component: () =>
                            import ("@/views/Contractor/ReferFriend/addEditFriend")
                            // meta: {
                            //   title: messages.ReferFriend,
                            //   breadcrumb: [
                            //     { name: messages.ReferFriend },
                            //     { name: messages.ReferFriend }
                            //   ]
                            // }
                    },
                    {
                        path: "/invoices",
                        name: "Invoices",
                        component: () =>
                            import ("@/views/Contractor/MonthlyInvoices/invoices"),
                        meta: {
                            title: messages.MonthlyInvoices,
                            breadcrumb: [
                                { name: messages.MonthlyInvoices },
                                { name: messages.MonthlyInvoices }
                            ]
                        }
                    },
                    {
                        path: "/add-invoice",
                        name: "Add Invoices",
                        component: () =>
                            import ("@/views/Contractor/MonthlyInvoices/add-invoices")
                            // meta: {
                            //   title: messages.MonthlyInvoices,
                            //   breadcrumb: [
                            //     { name: messages.MonthlyInvoices },
                            //     { name: messages.MonthlyInvoices }
                            //   ]
                            // }
                    },
                    {
                        path: "/edit-invoices/:uuid/invoice/:id",
                        name: "Edit Invoices",
                        component: () =>
                            import ("@/views/Contractor/MonthlyInvoices/add-invoices")
                            // meta: {
                            //   title: messages.MonthlyInvoices,
                            //   breadcrumb: [
                            //     { name: messages.MonthlyInvoices },
                            //     { name: messages.MonthlyInvoices }
                            //   ]
                            // }
                    },
                    {
                        path: "/manage-expanses",
                        name: "Manage Expanses",
                        component: () =>
                            import ("@/views/Contractor/ManageExpanses/manage-expanses")
                            // meta: {
                            //   title: messages.Manage_Expanses,
                            //   breadcrumb: [
                            //     { name: messages.Manage_Expanses },
                            //     { name: messages.Manage_Expanses }
                            //   ]
                            // }
                    }
                ]
            }
        ]
    });
}

if (process.env.PORTAL_TYPE == "PAYROLL_PARTNER") {
    router = new Router({
        mode: "history",
        routes: [{
                path: "",
                redirect: "login"
            },
            {
                path: "/login",
                name: "Login",
                component: () =>
                    import ("@/views/login/login")
            },
            {
                path: "/forget-password",
                name: "Forgetpassword",
                component: () =>
                    import ("@/views/login/forgetPassword")
            },
            {
              path: "/verification",
              name: "mfaVerification",
              component: () =>
                  import ("@/views/login/mfaVerification.vue")
          },
            {
                path: "/reset-password/:token",
                name: "ResetPassword",
                component: () =>
                    import ("@/views/login/resetPassword")
            },
            {
                path: "/complete-activation/:token",
                name: "CompleteActivation",
                component: () =>
                    import ("@/views/login/accountActivation")
            },
            {
                path: "/",
                component: () =>
                    import ("@/views/main"),
                meta: {
                    requiresAuth: true
                },
                children: [{
                        path: "/profile",
                        name: "Profile",
                        component: () =>
                            import ("@/views/Profile/profile"),
                        meta: {
                            title: messages.profile,
                            breadcrumb: [
                                { name: messages.profile },
                                { name: messages.profile }
                            ]
                        }
                    },

                    {
                        path: "/change-password",
                        name: "ChangePassword",
                        component: () =>
                            import ("@/views/Profile/changePassword"),
                        meta: {
                            title: messages.change_password,
                            breadcrumb: [
                                { name: messages.change_password },
                                { name: messages.change_password }
                            ]
                        }
                    },
                    {
                        path: "/my-information",
                        name: "/My Information",
                        component: () =>
                            import ("@/views/PayrollPartner/MyInformation/my-information"),
                        meta: {
                            title: messages.My_Contracts,
                            breadcrumb: [
                                { name: messages.My_Contracts },
                                { name: messages.My_Contracts }
                            ]
                        }
                    },
                    {
                        path: "/add-bank-info",
                        name: "Add Banking Info",
                        component: () =>
                            import ("@/views/PayrollPartner/MyInformation/addEditBankinginfo")
                            // meta: {
                            //   title: messages.manage_information,
                            //   breadcrumb: [
                            //     { name: messages.manage_information },
                            //     { name: messages.manage_information }
                            //   ]
                            // }
                    },
                    {
                        path: "/welcome-Page",
                        name: "WelcomePage",
                        component: () =>import ("@/views/PayrollPartner/DashBoard/welcome"),
                    },
                    {
                        path: "/edit-bank-info/:bank_id",
                        name: "Edit Banking Info",
                        component: () =>
                            import ("@/views/PayrollPartner/MyInformation/addEditBankinginfo")
                            // meta: {
                            //   title: messages.manage_information,
                            //   breadcrumb: [
                            //     { name: messages.manage_information },
                            //     { name: messages.manage_information }
                            //   ]
                            // }
                    },

                    {
                        path: "/invoices",
                        name: "/Invoices",
                        component: () =>
                            import ("@/views/PayrollPartner/MonthlyInvoices/invoices"),
                        meta: {
                            title: messages.Invoices,
                            breadcrumb: [
                                { name: messages.Invoices },
                                { name: messages.Invoices }
                            ]
                        }
                    },
                    {
                        path: "/add-invoice",
                        name: "/Add Invoices",
                        component: () =>
                            import ("@/views/PayrollPartner/MonthlyInvoices/add-invoices")
                            // meta: {
                            //   title: messages.Invoices,
                            //   breadcrumb: [
                            //     { name: messages.Invoices },
                            //     { name: messages.Invoices }
                            //   ]
                            // }
                    },
                    {
                        path: "/edit-invoices/:uuid/invoice/:id",
                        name: "Edit Invoices",
                        component: () =>
                            import ("@/views/PayrollPartner/MonthlyInvoices/add-invoices")
                            // meta: {
                            //   title: messages.MonthlyInvoices,
                            //   breadcrumb: [
                            //     { name: messages.MonthlyInvoices },
                            //     { name: messages.MonthlyInvoices }
                            //   ]
                            // }
                    },
                    {
                        path: "/my-contracts",
                        name: "/My Contracts",
                        component: () =>
                            import ("@/views/PayrollPartner/ManageContract/my-contracts"),
                        meta: {
                            title: messages.My_Contracts,
                            breadcrumb: [
                                { name: messages.My_Contracts },
                                { name: messages.My_Contracts }
                            ]
                        }
                    },
                    {
                        path: "/edit-contract/:id/:view",
                        name: "/Edit Contract",
                        component: () =>
                            import ("@/views/PayrollPartner/ManageContract/EditContract")
                            // meta: {
                            //   title: messages.My_Contracts,
                            //   breadcrumb: [
                            //     { name: messages.My_Contracts },
                            //     { name: messages.My_Contracts }
                            //   ]
                            // }
                    },
                    {
                        path: "/remits",
                        name: "Remits",
                        component: () =>
                            import ("@/views/PayrollPartner/MyRemits/remits"),
                        meta: {
                            title: messages.my_remits,
                            breadcrumb: [
                                { name: messages.my_remits },
                                { name: messages.my_remits }
                            ]
                        }
                    },
                    {
                        path: "/users",
                        name: "Users",
                        component: () =>
                            import ("@/views/PayrollPartner/ManageUser/users"),
                        meta: {
                            title: messages.my_user,
                            breadcrumb: [
                                { name: messages.my_user },
                                { name: messages.my_user }
                            ]
                        }
                    },
                    {
                        path: "/payslips",
                        name: "Payslip",
                        component: () =>
                            import ("@/views/PayrollPartner/ManagePayslips/payslip"),
                        meta: {
                            title: "Manage Payslips",
                            breadcrumb: [
                                { name: "Manage Payslip" },
                                { name: "Manage Payslip" }
                            ]
                        }
                    },
                    {
                        path: "/add-user",
                        name: "Add-Users",
                        component: () =>
                            import ("@/views/PayrollPartner/ManageUser/addEditUsers")
                    },
                    {
                        path: "/edit-payroll-user/:id",
                        name: "Edit-Users",
                        component: () =>
                            import ("@/views/PayrollPartner/ManageUser/addEditUsers")
                    },
                    {
                        path: "/view-user/:id",
                        name: "Edit-Users",
                        component: () =>
                            import ("@/views/PayrollPartner/ManageUser/viewUser")
                    },
                    {
                        path: "/roles",
                        name: "Roles",
                        component: () =>
                            import ("@/views/PayrollPartner/ManageSettings/ManageRole/roles"),
                        meta: {
                            title: messages.manage_role,
                            breadcrumb: [
                                { name: messages.manage_role },
                                { name: messages.manage_role }
                            ]
                        }
                    },
                    {
                        path: "/add-role",
                        name: "Add Roles",
                        component: () =>
                            import (
                                "@/views/PayrollPartner/ManageSettings/ManageRole/addEditRole"
                            )
                    },
                    {
                        path: "/edit-role/:id",
                        name: "Edit Roles",
                        component: () =>
                            import (
                                "@/views/PayrollPartner/ManageSettings/ManageRole/addEditRole"
                            )
                    }
                ]
            }
        ]
    });
}

router.beforeEach((to, from, next) => {
    if (to.matched.some(record => record.meta.requiresAuth)) {
        if (!localStorage.getItem("access_token") ||
            localStorage.getItem("access_token") == null
        ) {
            next({
                path: "/login",
                params: { nextUrl: to.fullPath }
            });
        } else {
            next();
        }
    } else {
        if (to.path === "/login") {
            if (localStorage.getItem("access_token") != null) {
                next({
                    path: "/profile",
                    params: { nextUrl: to.fullPath }
                });
            } else {
                next();
            }
        } else {
            next();
        }
    }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js